/* src/app/components/lead-details/participant-information/lead-information/lead-information.component.css */
nz-collapse-panel {
  margin: 0 0 8px;
}
/*# sourceMappingURL=lead-information.component-57FSNWZP.css.map */
